module.exports = __webpack_public_path__ + "img/icon2.1b64d57b.png";